import styled from "styled-components";

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const PageTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  color: #111;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 18px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #18a860; }
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const SearchWrap = styled.div`
  position: relative;
  flex: 1;
  max-width: 320px;
`;

export const SearchIcon = styled.span`
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #bbb;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px 0 36px;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  font-size: 14px;
  color: #111;
  background-color: #fff;
  transition: border-color 0.15s;

  &::placeholder { color: #bbb; }
  &:focus { outline: none; border-color: #1fbc70; }
`;

export const CountText = styled.p`
  font-size: 13px;
  color: #aaa;
  margin-left: auto;
`;

export const Card = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  overflow: hidden;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const Thead = styled.thead`
  background-color: #fafafa;
  border-bottom: 1px solid #f0f0f0;
`;

export const Th = styled.th<{ width?: string }>`
  padding: 12px 20px;
  font-size: 12px;
  font-weight: 600;
  color: #888;
  text-align: left;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
  width: ${({ width }) => width ?? "auto"};
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid #f5f5f5;
  &:last-child { border-bottom: none; }
  &:hover { background-color: #fafff9; }
`;

export const Td = styled.td`
  padding: 14px 20px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
`;

export const IndexCell = styled.span`
  font-size: 13px;
  color: #bbb;
  font-weight: 500;
`;

export const Thumbnail = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  object-fit: cover;
  background-color: #f0f0f0;
  display: block;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background-color: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #ccc;
`;

export const BuildingName = styled.span`
  font-weight: 600;
  color: #111;
  display: block;
`;

export const BuildingLabel = styled.span`
  font-size: 12px;
  color: #aaa;
  margin-top: 2px;
  display: block;
`;

export const CoordText = styled.span`
  font-size: 12px;
  color: #aaa;
  font-family: monospace;
`;

export const EmptyCell = styled.td`
  padding: 60px 20px;
  text-align: center;
  color: #bbb;
  font-size: 14px;
`;

export const DeleteButton = styled.button`
  height: 30px;
  padding: 0 12px;
  border: 1px solid #f0d0d0;
  border-radius: 7px;
  background-color: #fff5f5;
  color: #fc324a;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s;

  &:hover { background-color: #fde8e8; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;
